import { call, put, takeLatest } from 'redux-saga/effects';
import { SMART_EDIT_GEO_FILTER_MARKET_DATA_REQUEST, SMART_EDIT_GEO_FILTER_STATE_DATA_REQUEST } from '@src/middleware/actions/actionTypes';
import { getSmartEditGeoFilterDataRequest } from '@src/middleware/services/serviceInteraction/digitalSummary/smartEditGeoFilter/smartEditGeoFilter.service';
import { fetchSmartEditGeoFilterMarketError, fetchSmartEditGeoFilterMarketLoading, fetchSmartEditGeoFilterMarketSuccess, fetchSmartEditGeoFilterStateError, fetchSmartEditGeoFilterStateLoading, fetchSmartEditGeoFilterStateSuccess } from '@src/middleware/actions/ServiceInteraction/DigitalSolutions/smartEditGeoFilterActions';

export function* getSmartEditGeoFilterStateData(action: any) {
  try {
    yield put(fetchSmartEditGeoFilterStateLoading(true));

    const response = yield call(
      getSmartEditGeoFilterDataRequest,
      action?.payload
    );
    yield put(fetchSmartEditGeoFilterStateSuccess(response));
    yield put(fetchSmartEditGeoFilterStateLoading(false));
  } catch (error) {
    yield put(fetchSmartEditGeoFilterStateError(true));
    yield put(fetchSmartEditGeoFilterStateLoading(false));
  }
}

export function* getSmartEditGeoFilterMarketData(action: any) {
  try {
    yield put(fetchSmartEditGeoFilterMarketLoading(true));

    const response = yield call(
      getSmartEditGeoFilterDataRequest,
      action?.payload,
      "market"
    );
    yield put(fetchSmartEditGeoFilterMarketSuccess(response));
    yield put(fetchSmartEditGeoFilterMarketLoading(false));
  } catch (error) {
    yield put(fetchSmartEditGeoFilterMarketError(true));
    yield put(fetchSmartEditGeoFilterMarketLoading(false));
  }
}

export function* smartEditGeoFilterSaga() {
  yield takeLatest(
    SMART_EDIT_GEO_FILTER_STATE_DATA_REQUEST,
    getSmartEditGeoFilterStateData
  );
  yield takeLatest(
    SMART_EDIT_GEO_FILTER_MARKET_DATA_REQUEST,
    getSmartEditGeoFilterMarketData
  );
}
